/**
 * Compact vs desktop for the six device tables + RepeatableInstanceList.
 *
 * Desktop web holds through phone-landscape / mid-size windows. Compact is
 * phone-portrait web only (< 480, same floor as ViewRequests mobile landscape).
 * Native stays compact at any width.
 */

import { Platform } from 'react-native';

import type { RecordTableLayout } from './recordTableStyles';

/** Phone-portrait ceiling — keep the full column set above this. */
export const RECORD_TABLE_DESKTOP_MIN_WIDTH = 480;

export function resolveRecordTableLayout(
  viewportWidth: number | undefined,
): RecordTableLayout {
  if (Platform.OS !== 'web') {
    return 'compact';
  }
  const width = viewportWidth ?? Number.POSITIVE_INFINITY;
  if (!Number.isFinite(width)) {
    return 'desktop';
  }
  return width < RECORD_TABLE_DESKTOP_MIN_WIDTH ? 'compact' : 'desktop';
}
